<div class="box">
    <i class="flaticon-metal-gear gear1"></i>
    <i class="flaticon-metal-gear gear2"></i>
</div>
<span> Processing the data, please wait <b [class.blinker]="blink1">.</b> <b [class.blinker]="blink2">.</b> <b
        [class.blinker]="blink3">.</b> </span>